import { addClass, removeClass, scrollTo } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

import { scrollHighlightToView } from '../../helpers/helpers';
import { ScrollBottomTemplate } from './scrollToBottom.template';

export class ScrollToBottom {
	constructor(props) {
		this.data = {
			id: props.id,
		};

		this.init();
		this.html = ScrollBottomTemplate(this.data);
	}

	onScrollToBottom(event) {
		if (event.target) {
			if (ENGT_CHAT.get('manualScrollOnScreens')) {
				const { id } = event.target;
				const scrolled = event.target.scrollTop + event.target.clientHeight;
				const total = event.target.scrollHeight;
				const remaining = total - scrolled;
				const isChatScreen = id === 'engtChatContent';
				const remainingHeight = isChatScreen ? 300 : 30;

				const engtScrollBtnElement = document.querySelector(
					`#${isChatScreen ? 'engtChatWrapper' : id} > #engtScrollBtn`
				);

				if (scrolled < total && remaining > remainingHeight) {
					removeClass(engtScrollBtnElement, 'engt-scrl-down-btn-hidden');
					if (isChatScreen) {
						addClass(
							engtScrollBtnElement,
							ENGT_CHAT.get('config.remove_branding')
								? 'engt-scrl-down-btn-chat-screen-bottom-without-brand'
								: 'engt-scrl-down-btn-chat-screen-bottom-with-brand'
						);
					}
				} else {
					addClass(engtScrollBtnElement, 'engt-scrl-down-btn-hidden');
					if (isChatScreen) {
						removeClass(
							engtScrollBtnElement,
							ENGT_CHAT.get('config.remove_branding')
								? 'engt-scrl-down-btn-chat-screen-bottom-without-brand'
								: 'engt-scrl-down-btn-chat-screen-bottom-with-brand'
						);
					}
				}
			}
		}
	}

	scrollDown(elem) {
		if (elem) {
			const id = elem.getAttribute('data-scroll-for');
			const target = document.getElementById(id);

			if (id === 'engtChatContent') {
				scrollHighlightToView();
			} else {
				scrollTo(target, target.scrollTop + 150, 400);
			}
		}
	}

	init() {
		ENGT_CHAT.set('onScrollToBottom', this.onScrollToBottom);
		ENGT_CHAT.set('scrollDown', this.scrollDown);
	}

	render() {
		return this.html;
	}
}
